module.exports = __webpack_public_path__ + "img/hbbg.9107b595.png";